import { navigateToExternalUrl } from './location'

/**
 * Created to deal with Safari blocking popups issue. Similar to useOpenWindowSafely hook.
 * If the new tab can't be created, the link will open in the same tab.
 */
export const catchBlockedPopUp = (url: string) => {
  const newWindow = window.open() as any
  try {
    newWindow.focus()
    newWindow.location = url

    return newWindow
  } catch (e) {
    navigateToExternalUrl(url)
  }
}
